"use strict";

exports.__esModule = true;
exports["default"] = reduceReducers;

function reduceReducers() {
  for (var _len = arguments.length, reducers = Array(_len), _key = 0; _key < _len; _key++) {
    reducers[_key] = arguments[_key];
  }

  return function (previous, current) {
    return reducers.reduce(function (p, r) {
      return r(p, current);
    }, previous);
  };
}

module.exports = exports["default"];


/*****************
 ** WEBPACK FOOTER
 ** ../~/reduce-reducers/lib/index.js
 ** module id = 394
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/reduce-reducers/lib/index.js
 ** module id = 394
 ** module chunks = 1
 **/